"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const AddProduct_1 = __importDefault(require("@/pages/Products/pages/AddProduct"));
const EditProducts_1 = __importDefault(require("@/pages/Products/pages/EditProducts"));
const Products_1 = __importDefault(require("@/pages/Products"));
const Components_1 = __importDefault(require("@/pages/Components"));
const ApprovedFeedstock_1 = __importDefault(require("@/pages/ApprovedFeedstock"));
const Sites_1 = __importDefault(require("@/pages/Sites"));
const AssociateSystemComponents_1 = __importDefault(require("@/pages/Sites/pages/AssociateSystemComponents"));
const Evaluators_1 = __importDefault(require("@/pages/Evaluators"));
const OtherCosts_1 = __importDefault(require("@/pages/OtherCosts"));
const Ports_1 = __importDefault(require("@/pages/Ports"));
const Users_1 = __importDefault(require("@/pages/Users"));
exports.default = [
    {
        path: "/",
        name: "Home",
        Component: Components_1.default,
    },
    {
        path: "/approved-feedstock",
        name: "Approved Feedstock",
        Component: ApprovedFeedstock_1.default,
    },
    {
        path: "/products",
        name: "Products",
        Component: Products_1.default,
        routes: [
            {
                path: "/add-product",
                name: "Add Products",
                Component: AddProduct_1.default,
            },
            {
                path: "/:productId",
                name: "Edit Products",
                Component: EditProducts_1.default,
            },
        ],
    },
    {
        path: "/sites-and-systems",
        name: "Sites",
        Component: Sites_1.default,
        routes: [
            {
                path: "/:systemId",
                name: "Associate System Components",
                Component: AssociateSystemComponents_1.default,
            },
        ],
    },
    {
        path: "/ports",
        name: "Ports",
        Component: Ports_1.default
    },
    {
        path: "/evaluators",
        name: "Evaluators",
        Component: Evaluators_1.default,
    },
    {
        path: "/other-costs",
        name: "Other Costs",
        Component: OtherCosts_1.default,
    },
    {
        path: "/users",
        name: "Users",
        Component: Users_1.default
    }
];
